<template>
  <div class="content-wrapper">
    <!-- <app-overlay-loader v-if="preloader" /> -->
    <!-- <div class="row"> -->
        <!-- <dynamic-form-preview v-bind:Id="jobId"></dynamic-form-preview> -->
        <form-preview v-if="show == true" :type="type" :id="form_body_id" :form_id="form_id" :form_revision_id="form_revision_id" :taskId="task_id"></form-preview>
      <!-- </div> -->
  </div>
</template>

<script>
import { ModalMixin } from "../../../../../Mixins/ModalMixin";
import { axiosGet} from "../../../../../../app/Helpers/AxiosHelper";
import * as actions from "../../../../../Config/ApiUrl";

export default {
  name: "FormBuilderModal",
  mixins: [ModalMixin],
//   props: {
//     jobId: Number,
//   },
  data() {
    return {
        show: false,
        jobId:0,
        task_id: 0,
        form_id: 0,
        form_body_id: 0,
        form_revision_id: 0,
        type: 'bidForm',
    //   preloader: true,
    //   formhide:false,
      inputs: {
        yes: "no",
      },
      modalId: "demo-add-edit-Modal",
      modalTitle: this.$t("add"),
    };
  },
  created() {
        let id = this.$attrs['props'];
        this.jobId = id.id;
        // this.preloader = false;
        // this.formhide = true;
        
    // this.modalTitle = this.$t("Form Builder");
    // this.preloader = true;
  },
  methods: {
    //Updated Work
    getData() {

      axiosGet(`${actions.FORM_BUILDER_GET}/${this.jobId}`)
        // axiosGet(`admin/job/bid/form/2?form_id=${form_id}`)
        .then((res) => {
          if (res.data.length !== 0) {
            this.task_id = res.data.assigned_bid_form[0].id;
            this.form_id = res.data.assigned_bid_form[0].bid_form[0].form_id;
            this.form_body_id = res.data.assigned_bid_form[0].bid_form[0].form_body_id;
            this.form_revision_id = res.data.assigned_bid_form[0].bid_form[0].id;
            this.show = true;
          }
        })
        .catch((res) => {
          console.error(res);
        });
    },
  },
  mounted() {
    this.getData();
    $("#removeclass .modal-dialog ").removeClass("modal-dialog-scrollable");
    this.$store.state.inputMode.type = false;
  },
};
</script>
